import '@mdi/font/css/materialdesignicons.css'

import CheckmarkIcon from '@/js/components/Shared/IconSelect/Icons/CheckmarkIcon.vue'
import InfoIcon from '@/js/components/Shared/IconSelect/Icons/InfoIcon.vue'
import ShortArrowLeftIconSvg from '@/js/components/Shared/SvgSelect/SVG/ShortArrowLeftIconSvg.vue'
import ShortArrowRightIconSvg from '@/js/components/Shared/SvgSelect/SVG/ShortArrowRightIconSvg.vue'
import ShortArrowDownIconSvg from '@/js/components/Shared/SvgSelect/SVG/ShortArrowDownIconSvg.vue'
import ShortArrowFilledDownIconSvg from '@/js/components/Shared/SvgSelect/SVG/ShortArrowFilledDownIconSvg.vue'
import WarningIcon from '@/js/components/Shared/IconSelect/Icons/WarningIcon.vue'

export default {
  iconfont: 'mdiSvg',
  values: {
    // complete: '',
    // cancel: '',
    // close: '',
    // delete: '', // delete (e.g. v-chip close)
    // clear: '',
    success: {
      component: CheckmarkIcon,
    },
    info: {
      component: InfoIcon,
    },
    warning: {
      component: InfoIcon,
    },
    error: {
      component: WarningIcon,
    },
    prev: {
      component: ShortArrowLeftIconSvg,
    },
    next: {
      component: ShortArrowRightIconSvg,
    },
    dropdown: {
      component: ShortArrowDownIconSvg,
    },
    dropdownFilled: {
      component: ShortArrowFilledDownIconSvg,
    },
    // checkboxOn: '',
    // checkboxOff: '',
    // checkboxIndeterminate: '',
    // delimiter: '', // for carousel
    // sort: '',
    // expand: '',
    // menu: '',
    // subgroup: '',
    // dropdown: '',
    // radioOn: '',
    // radioOff: '',
    // edit: '',
    // ratingEmpty: '',
    // ratingFull: '',
    // ratingHalf: '',
    // loading: '',
    // first: '',
    // last: '',
    // unfold: '',
    // file: '',
  },
}
